import { render, staticRenderFns } from "./DashboardClinic.html?vue&type=template&id=3bae5e3c&lang=html&external"
import script from "./DashboardClinic.vue?vue&type=script&lang=js"
export * from "./DashboardClinic.vue?vue&type=script&lang=js"
import style0 from "./DashboardClinic.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports